export default function SectionHeaderDivider() {
  return <span className="w-4 h-px bg-gray-400"></span>;
}
